import React, { useEffect, useState } from 'react'
import CustomListbox, { ListItem } from 'components/listbox'
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'
import handleNotification from 'utils/toast/handleNotification'

import WORDING from 'constants/wording'
import { getBlockStatusReasons, setBlockCard } from 'api/credit-card'
import { trackEvent } from 'analytics/trackFunctions'

const {
  TARJETA_MODAL_TITULO,
  TARJETA_BLOQUEADA_TOAST,
  BLOCK_TEXT,
  TARJETA_MODAL_DESCRIPCION,
  OPTION_SELECTED,
  MOTIVO
} = WORDING

const BlockCardModal = ({ showModal, setShowModal, card, getCardData }) => {
  const [selectedValue, setSelectedValue] = useState<ListItem>(null)
  const [reasonsInput, setReasonsInput] = useState('')
  const [loadingBlockCard, setLoadingBlockCard] = useState(false)
  const [blockReasons, setBlockReasons] = useState<ListItem[]>([])
  const { successToast } = handleNotification()

  useEffect(() => {
    getBlockStatusReasons().then((res) => {
      setBlockReasons(res.map(({ code, text }) => ({ key: code, name: text })))
    })
  }, [])

  async function onConfirm() {
    setLoadingBlockCard(true)
    await setBlockCard(
      {
        card_blocked_comment: reasonsInput,
        card_status_reason: selectedValue.key
      },
      card.uuid
    )
    getCardData()
    setLoadingBlockCard(false)
    setShowModal(false)
    successToast(TARJETA_BLOQUEADA_TOAST)
    trackEvent({
      eventName: 'bille_popup_tarjeta_bloqueo_exitoso',
      props: {
        detalle_de_bloqueo: reasonsInput,
        motivo_de_bloqueo: selectedValue.key
      }
    })
  }

  return (
    <ModalContainer
      title={TARJETA_MODAL_TITULO}
      className='!max-w-md'
      isShown={showModal}
      setModalFunction={setShowModal}
    >
      <p className='font-medium text-xs text-color-black mt-4 leading-140 text-center mb-4'>
        {TARJETA_MODAL_DESCRIPCION}
      </p>

      {blockReasons && (
        <CustomListbox
          label={OPTION_SELECTED}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          list={blockReasons}
        />
      )}
      <div style={{ position: 'relative', width: '100%' }}>
        <textarea
          value={reasonsInput}
          onChange={(e) => setReasonsInput(e.target.value)}
          className='w-full mt-4 resize-none pt-5 pb-1 rounded focus:outline-none  focus:ring-gray-500 focus:ring-2'
        />
        <small style={{ position: 'absolute', top: '20px', left: '15px' }}>
          {MOTIVO}
        </small>
      </div>
      <div className='flex mt-8 justify-between gap-12'>
        <PrimaryButton
          buttonText='Cancelar'
          outlined
          type='submit'
          primaryButtonFunction={() => {
            setReasonsInput('')
            setShowModal(false)
          }}
        />

        <PrimaryButton
          buttonText={BLOCK_TEXT}
          type='submit'
          margins=''
          primaryButtonFunction={() => {
            onConfirm()
          }}
          isDisabled={!reasonsInput}
          isLoading={loadingBlockCard}
        />
      </div>
    </ModalContainer>
  )
}

export default BlockCardModal
